module.exports = __webpack_public_path__ + "static/media/r21.aef16b8b.png";